function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1192_401)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.5 3.5H11.5C7.08172 3.5 3.5 7.08172 3.5 11.5V28.5C3.5 32.9183 7.08172 36.5 11.5 36.5H28.5C32.9183 36.5 36.5 32.9183 36.5 28.5V11.5C36.5 7.08172 32.9183 3.5 28.5 3.5Z",
  fill: "#EF4452"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.5002 28.4998C25.9882 28.4998 25.4772 28.3047 25.0862 27.9137L12.0862 14.9137C11.3052 14.1327 11.3052 12.8668 12.0862 12.0857C12.8672 11.3047 14.1332 11.3047 14.9142 12.0857L27.9142 25.0857C28.6952 25.8667 28.6952 27.1327 27.9142 27.9137C27.5232 28.3047 27.0122 28.4998 26.5002 28.4998Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5002 28.4998C12.9882 28.4998 12.4772 28.3047 12.0862 27.9137C11.3052 27.1327 11.3052 25.8667 12.0862 25.0857L25.0862 12.0857C25.8672 11.3047 27.1332 11.3047 27.9142 12.0857C28.6952 12.8668 28.6952 14.1327 27.9142 14.9137L14.9142 27.9137C14.5232 28.3047 14.0122 28.4998 13.5002 28.4998Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1192_401"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
})));

function SvgPaymentfail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentfail);
export default __webpack_public_path__ + "static/media/paymentfail.826feaa3.svg";
export { ForwardRef as ReactComponent };